import { BaseParser, DATA_TYPE_PICTURE } from './baseExtractor';

const iconPicFile = 'picture.png';


class PictureExtractor extends BaseParser {
  // eslint-disable-next-line no-unused-vars
  async _doParse(parent, fileName, data, report) {
    const returnValue = this.getNewReturnValue();
    returnValue.processedData = data;
    returnValue.success = true;
    returnValue.icon = iconPicFile;
    returnValue.dataType = DATA_TYPE_PICTURE;
    return returnValue;
  }
}

export{
  PictureExtractor,
};
